import {
  Component,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Breakpoint, BreakpointState, MediaQueryService, Lesson } from '@tdwb/core';

@Component({
  selector: 'td-wb-trading-learn-related-lessons',
  templateUrl: './trading-learn-related-lessons.component.html',
  styleUrls: ['./trading-learn-related-lessons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TradingLearnRelatedLessonsComponent implements AfterViewInit {
  private static readonly CARD_MARGIN_DESKTOP: number = 30;
  private static readonly CARD_MARGIN_TABLET: number = 15;

  @Input() contextualLesson: Lesson;
  @Input() relatedLessons: Array<Lesson>;
  @Output() readonly lessonSelected: EventEmitter<Lesson> = new EventEmitter<Lesson>();
  @ViewChild('relatedLessonsSection', { static: true }) relatedLessonsSection: ElementRef;

  isDesktop: boolean;
  isMobile: boolean;
  width: number;

  constructor(private mediaQueryService: MediaQueryService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.GT_MD, Breakpoint.GT_LG)
      .pipe(takeUntilDestroyed())
      .subscribe((breakpointState: BreakpointState): void => {
        this.isMobile = breakpointState.isBreakpointMatch(Breakpoint.SM);
        this.isDesktop = breakpointState.isBreakpointMatch(Breakpoint.GT_MD);
        this.setDynamicWidthForCard();
        this.changeDetectorRef.markForCheck();
      });
  }

  selectLesson(lesson: Lesson, index: number): void {
    this.lessonSelected.emit(lesson);
    if (this.relatedLessons[index] !== undefined) {
      this.relatedLessons[index] = this.contextualLesson;
      this.changeDetectorRef.markForCheck();
    }
  }

  ngAfterViewInit(): void {
    this.setDynamicWidthForCard();
  }

  trackById(_index: number, lesson: Lesson): string {
    return lesson?.uniqueKey;
  }

  private setDynamicWidthForCard(): void {
    if (this.isMobile) {
      this.width = 300;
    } else {
      this.width = (this.relatedLessonsSection?.nativeElement?.clientWidth -
        (2 * (this.isDesktop ?
          TradingLearnRelatedLessonsComponent.CARD_MARGIN_DESKTOP : TradingLearnRelatedLessonsComponent.CARD_MARGIN_TABLET))
      ) / 3;
    }
  }
}
